<template lang="pug">
div
  UiDialogModal(
    v-for="dialog in confirmDialogs"
    :key="dialog.id"
    :params="dialog.params"
    @confirm="confirmDialog(dialog)"
    @reject="rejectDialog(dialog)"
  )
</template>

<script>
import { confirmDialogs } from "@/common/dialogs";
import UiDialogModal from "./UiDialogModal.vue";

export default {
  components: {
    UiDialogModal,
  },

  setup() {
    return {
      confirmDialogs,
    };
  },

  methods: {
    confirmDialog(dialog) {
      dialog.resolveHandler(true);
      this.scheduleDestroy(dialog);
    },

    rejectDialog(dialog) {
      dialog.rejectHandler(false);
      this.scheduleDestroy(dialog);
    },

    scheduleDestroy(dialog) {
      setTimeout(() => {
        const index = confirmDialogs.value.findIndex((d) => d.id === dialog.id);
        confirmDialogs.value.splice(index, 1);
      }, 1000);
    },
  },
};
</script>
